import React from "react";
//import Button from "react-bootstrap/Button";
import Figure from "react-bootstrap/Figure";
//import Image from "react-bootstrap/Image";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
//import Tooltip from "react-bootstrap/Tooltip";

function ItemDisplay(props) {
  let p = props;
  const renderTooltip = (props) => (
    <Popover {...props}>
      <Popover.Title>
        {p.item.name}
      </Popover.Title>
      <Popover.Content>
        {p.item.type}
        {
          p.item.attackRange &&
            <div> Att: {p.item.attackRange.min} - {p.item.attackRange.max} </div>
        }
        {
          p.item.defense != null &&
            <div> Def: {p.item.defense} </div>
        }
        {/* WE NEED TO HANDLE FOR NON EQUIPPABLE ITEMS
          p.item.equipable === true &&
            <Button onClick={() => p.equipItem(p.index)}> Equip </Button>
        */}
        <i>(click to equip)</i>
        
      </Popover.Content>
    </Popover>
  );

  return (
      <OverlayTrigger
        placement="right"
        overlay={renderTooltip}
      >
        <Figure onClick={() => p.equipItem(p.index)}>
          <Figure.Image
            width={80}
            height={80}
            alt={p.item.name}
            src={require("../assets/".concat(p.item.image))}
            />
            <Figure.Caption>
              {/*p.item.name /*not sure if i want this caption*/}
            </Figure.Caption>
        </Figure>
      </OverlayTrigger>
  );
}

export default ItemDisplay;
